import React from 'react';
import Container4 from 'assets/images/Container-4.png';
import { ChevronRight } from 'lucide-react';

const ExpertSupportSection = () => {
  return (
    <div className="w-full">
      {/* Hero Section Superior */}
      <div 
        className="py-20 px-4 sm:px-6 lg:px-8"
        style={{
          background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
          position: 'relative'
        }}
      >
        {/* Patrón de fondo */}
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `radial-gradient(circle at 25% 25%, white 2px, transparent 2px),
                             radial-gradient(circle at 75% 75%, white 2px, transparent 2px),
                             linear-gradient(45deg, transparent 40%, rgba(255,255,255,0.1) 50%, transparent 60%)`,
            backgroundSize: '50px 50px, 50px 50px, 30px 30px'
          }}
        ></div>
        
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Comprehensive Digital Marketing Solutions
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Our tailored digital marketing strategies meet your business's unique needs, enhancing your online presence and driving growth. From SEO and social media management to content creation and online advertising, we provide a full suite of services to ensure your brand stands out.
          </p>
          <button className="bg-white text-red-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors flex items-center space-x-2 mx-auto shadow-lg">
            <span>GET STARTED</span>
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      {/* Sección Expert Support */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col-reverse lg:flex-row gap-12 items-center">
            
            {/* Columna izquierda - Contenido de texto */}
            <div className="p-8">
              <h3 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-6 leading-tight">
                Expert Support and<br />
                Consultation
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed mb-8">
                Our dedicated team of digital marketing experts is available to provide ongoing support and consultation, ensuring your campaigns are optimized for success. Whether you need help with strategy, implementation, or analysis, we are here to guide you every step of the way.
              </p>
              <button className="bg-red-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-red-700 transition-colors flex items-center space-x-2 shadow-lg">
                <span>SCHEDULE A CONSULTATION</span>
                <ChevronRight size={20} />
              </button>
            </div>

            {/* Columna derecha - Imagen con overlay de datos */}
            <div className="relative">
              <img
                src={Container4}
                alt="Expert team working on digital marketing"
                className="w-full h-auto"
              />
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertSupportSection;
